function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.25 18.0001C29.25 22.2802 25.7802 25.75 21.5001 25.75H9.49973C8.53323 25.75 7.74973 24.9665 7.74973 24C7.74973 23.0335 8.53323 22.25 9.49973 22.25H21.5001C23.8472 22.25 25.75 20.3472 25.75 18.0001C25.75 15.6529 23.8472 13.7502 21.5001 13.7502H9.49973C8.53323 13.7502 7.74973 12.9667 7.74973 12.0002C7.74973 11.0337 8.53323 10.2502 9.49973 10.2502H21.5001C25.7802 10.2502 29.25 13.7199 29.25 18.0001Z",
  fill: "#306bf6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5003 7.75L9.49991 7.75005C7.15275 7.75005 5.25 9.65281 5.25 12C5.25 14.3471 7.15276 16.2499 9.49992 16.2499H21.5003C22.4668 16.2499 23.2503 17.0334 23.2503 17.9999C23.2503 18.9664 22.4668 19.7499 21.5003 19.7499H9.49992C5.21976 19.7499 1.75 16.2801 1.75 12C1.75 7.71982 5.21974 4.25006 9.49989 4.25005L21.5003 4.25C22.4668 4.25 23.2503 5.0335 23.2503 5.99999C23.2503 6.96649 22.4668 7.75 21.5003 7.75Z",
  fill: "#306bf6"
});

function SvgSandbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.7d7bde9d.svg";
export { ForwardRef as ReactComponent };